<script>

    export let options = [];
    
    export let value = 0;

    function labelText( v ){
        if( v < 1 ){
            return options[1];
        }
        if( v > 6 ){
            return options[6];
        }
        return options[v];
    }

    $: focus = Math.floor( value / (10 / (options.length-0.1) ) || 0 );
    $: notZero = value > 0;
    $: label = labelText( focus );

</script>

<label>
    <p>
        {#if options.length < 4}
            {#each options as option, i}
                <span class:text-s={i !== focus}>{option}</span>
            {/each}
        {:else}
            <span class:text-s={focus !== 0}>{options[0]}</span>
            <span class:text-s={focus < 1 || focus > 6}>{label}</span>
            <span class:text-s={focus < 7}>{options[options.length-1]}</span>
        {/if}
    </p>
    <input class:notZero type="range" min={0} max={10} step={0.1} bind:value={value} on:change />
</label>

<style>

    label {
        margin: 1em 0;
    }

    p {
        display: flex;
        justify-content: space-between;
        min-height: 1.2em;
    }
    
    span {
        transition: font-size 200ms ease;
    }

    label, input {
        display: block;
        width: 100%;
    }

    input.notZero[type=range]::-webkit-slider-thumb {
        background: var(--color);
    }
    input.notZero[type=range]::-moz-range-thumb {
        background: var(--color);
    }

</style>